import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import Button, { ButtonVariants } from '../Button/Button'
import Container from '../Container/Container'
import Fixture from '../Fixture/Fixture'
import { Col, Grid, Row } from '../Grid'
import { Icon } from '../Icon/Icon'

import styles from './ContactBlock.module.css'

export interface ContactBlockProps {
  title: string
  subtitle: string
  email: string
  phoneNumbers: string[]
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  theme?: ComponentTheme
  launchForm?: string
  testID?: string
  moduleId?: string
}

export default function ContactBlock({
  title,
  subtitle,
  email,
  phoneNumbers,
  verticalPadding,
  noPaddingBottom,
  theme = ComponentTheme.primary,
  launchForm,
  testID,
  moduleId,
}: ContactBlockProps) {
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <Container>
        <div className={styles.base} data-testid={testID}>
          <Text
            Tag="h2"
            size={TextSizes.primaryTitleLrg}
            className={styles.title}
          >
            {title}
          </Text>
          <Text Tag="h3" size={TextSizes.bodyLrg} className={styles.subtitle}>
            {subtitle}
          </Text>
          <Grid>
            <Row>
              <Col variant="col-1/2--md" cssClass={styles.phoneNumbers}>
                <div className={styles.iconContainer}>
                  <Icon type="Call" responsive={true} />
                </div>
                <div className={styles.phonenumbers}>
                  {phoneNumbers?.map(number => (
                    <a href={`tel: ${number}`} key={`number-${number}`}>
                      <Text size={TextSizes.bodyLrg} className={styles.number}>
                        {number}
                      </Text>
                    </a>
                  ))}
                </div>
              </Col>
              <Col variant="col-1/2--md">
                <div className={styles.iconContainer}>
                  <Icon type="Email" responsive={true} />
                </div>
                <Button
                  variant={ButtonVariants.textLinkLight}
                  link={`mailto:${email}`}
                  launchForm={launchForm}
                >
                  {email}
                </Button>
              </Col>
            </Row>
          </Grid>
        </div>
      </Container>
    </Fixture>
  )
}
